var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('main',{staticClass:"main",attrs:{"id":"top"}},[_c('div',{staticClass:"container-fluid px-0",attrs:{"data-layout":"container"}},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }